module.exports = __webpack_public_path__ + "assets/img/bbdbtb.49383ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/bbdbtb.png
// module id = CAJg
// module chunks = 128